export const userSidebarStyle = {
	header: {
		boxShadow: 'var(--box-shadow--1)',
		backgroundColor: 'var(--default-white)',
	},
	wrap: {
		display: 'flex',
		maxWidth: '275px',
		width: '100%',
		minHeight: 'calc(100vh - 80px)',
		paddingRight: '24px',
		borderRight: '1px solid var(--neutral-100)',
		background: 'var(--default-white)',
		boxShadow: '0px 4px 5px -7px rgba(40, 103, 131, 0.6) inset, var(--box-shadow--1)',
		position: 'relative',

		'&:after': {
			content: "''",
			position: 'absolute',
			left: '-1000px',
			boxShadow: '0px 4px 5px -7px rgba(40, 103, 131, 0.6) inset',
			width: '1000px',
			backgroundColor: 'var(--default-white)',
			height: ' 100%',
		},
	},
	buttonCreate: {
		fontWeight: 700,
		marginTop: '24px',
	},
	spacer: {
		flex: '1 1',
	},
	sidebar: {
		width: '100%',
		minWidth: '250px',
		overflow: 'auto',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',

		'&::-webkit-scrollbar': {
			display: 'none',
		},

		'& button': {
			height: '44px',
		},
	},
	menu: {
		display: 'flex',
		flexDirection: 'column',

		'& .active': {
			background: 'var(--primary-100)',
			color: 'var(--primary-500) !important',

			'& svg path': {
				fill: 'var(--primary-500)',
			},
		},

		'& a:hover': {
			background: 'var(--primary-100)',
		},
	},
	menuItem: {
		display: 'flex',
		justifyContent: 'flex-start',
		gap: '12px',
		alignItems: 'center',
		height: '40px',
		padding: '10px 16px',
		marginBottom: '8px',
		color: 'var(--neutral-400)',
		fontSize: '16px',
		lineHeight: '24px',
		transition: '.3s',
		borderRadius: '8px',
	},

	menuTreeItem: {
		padding: '0 16px',
		marginBottom: '8px',
	},

	tree: {
		width: '100%',

		'.MuiTreeItem-content': {
			position: 'relative',
			width: '100%',
			borderRadius: '8px',
			padding: 0,
			background: 'none',

			'&.Mui-focused.Mui-selected, &.Mui-selected, &.Mui-selected:hover, &:hover': {
				background: 'none',
			},

			'.MuiTreeItem-label': {
				color: 'var(--neutral-400)',
				padding: '8px 0',
				borderRadius: '8px',
				paddingLeft: 0,

				'.MuiBox-root': {
					display: 'flex',
					alignItems: 'center',
					gap: '10px',
				},
			},

			'.MuiTreeItem-iconContainer': {
				position: 'absolute',
				width: '20px',
				right: '0',
				zIndex: 1,
				marginRight: 0,
			},
		},

		'.Mui-selected.Mui-focused': {
			background: 'none',
		},

		'.MuiCollapse-root': {
			marginLeft: '16px',
			position: 'relative',

			'.MuiTreeItem-content': {
				background: 'none',
				'&:hover': {
					background: 'none',
				},
			},

			'&::before': {
				content: '" "',
				display: 'block',
				position: 'absolute',
				top: '19px',
				left: '0',
				width: '1px',
				height: 'calc(100% - 38px)',
				backgroundColor: 'var(--neutral-100)',
			},

			'.MuiTreeItem-label': {
				marginLeft: '23px',
				padding: '10px 5px',
				position: 'relative',
				background: 'none',

				'&::before': {
					content: '" "',
					display: 'block',
					position: 'absolute',
					top: '50%',
					transform: 'translateY(-50%)',
					left: '-25px',
					width: '5px',
					height: '5px',
					borderRadius: '50%',
					backgroundColor: 'var(--neutral-100)',
				},
			},

			'.Mui-selected .MuiTreeItem-label': {
				background: 'var(--primary-100)',
				color: 'var(--primary-500)',
				borderRadius: '8px',

				'&::before': {
					backgroundColor: 'var(--primary-500)',
				},
			},
		},
	},
	arrowTop: {
		transform: 'rotate(180deg)',
	},
	sendMailModal: {
		'.MuiPaper-root': {
			width: '100%',
			minWidth: '750px',
			padding: '48px',
		},
	},

	newEventModal: {
		'.MuiPaper-root': {
			position: 'relative',
			minWidth: '1170px',
			width: '100%',
			maxHeight: 'calc(100% - 48px)',
			height: '100%',
			paddingTop: '48px',
			margin: '0 15px',
			borderRadius: '8px 8px 0 0 ',
		},

		'&.MuiDialog-root': {
			height: 'calc(100% - 80px)',
		},
	},

	iconWrapper: {
		display: 'flex',
		alignItems: 'center',

		svg: {
			path: {
				fill: 'var(--default-white)',
			},
		},
	},
	moneyIconWrapper: {
		display: 'flex',
		alignItems: 'center',

		svg: {
			path: {
				fill: 'var(--primary-500)',
			},
		},
	},

	disabledIcon: {
		svg: {
			path: {
				fill: 'var(--primary-200)',
			},
		},
	},

	modalLogin: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 200px',
			width: '100%',
		},
	},

	modalBid: {
		'.MuiPaper-root': {
			maxWidth: '972px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 80px',
			},

			'@media (max-width: 639.98px)': {
				padding: '48px 20px',
			},
		},
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '972px',
			padding: '48px 12px',
			width: '100%',
		},
	},

	modalTickets: {
		'.MuiPaper-root': {
			position: 'relative',
			maxWidth: '1170px',
			width: '100%',
			maxHeight: 'calc(100% - 48px)',
			height: '100%',
			padding: '48px 38px 0 48px',
			scrollbarGutter: 'stable',
			margin: '0 15px',
			borderRadius: '8px 8px 0 0 ',
		},

		'&.MuiDialog-root': {
			height: 'calc(100% - 80px)',
		},
	},
};
